import _ from 'lodash';
import constants from '../../../config/constants';
import aldoMarker from '../../../static/styles/svg/aldoMarker';
import americaninoMarker from '../../../static/styles/svg/americaninoMarker';
import blueExpressMarker from '../../../static/styles/svg/blueExpressMarker';
import cartersMarker from '../../../static/styles/svg/cartersMarker';
import chilexpressMarker from '../../../static/styles/svg/chilexpressMarker';
import clarksMarker from '../../../static/styles/svg/clarksMarker';
import etamMarker from '../../../static/styles/svg/etamMarker';
import falabellaMarker from '../../../static/styles/svg/falabellaMarker';
import fcomGreenMarker from '../../../static/styles/svg/fcomGreenMarker';
import maestroMarker from '../../../static/styles/svg/maestroMarker';
import mangoMarker from '../../../static/styles/svg/mangoMarker';
import metroMarker from '../../../static/styles/svg/metroMarker';
import plazaMarker from '../../../static/styles/svg/plazaMarker';
import sodimacMarker from '../../../static/styles/svg/sodimacMarker';
import sybillaMarker from '../../../static/styles/svg/sybillaMarker';
import tottusMarker from '../../../static/styles/svg/tottusMarker';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

const { MONTHS, timeZones } = constants;

const getScreen3Height = (type, isError = {}) => {
  if (isError[type] && isError[type].isError) {
    return '35vh';
  }
  if (type === constants.AVAILABILITY_HOMEDELIVERY) {
    return '50vh';
  }
  return '75vh';
};

const calculateHeightWidth = (deviceType, screen, type, isError) => {
  if (deviceType === 'desktop') {
    return { width: 360, height: '100%' };
  }

  const screenHeightMapper = {
    screen1: '50vh',
    screen2: 'auto',
    screen3: getScreen3Height(type, isError),
  };
  return { width: '100%', height: screenHeightMapper[screen] || '100vh' };
};

const getStoreIcon = (store) => {
  switch (store) {
    case 'tottus':
      return tottusMarker;

    case 'sodimac':
      return sodimacMarker;

    case 'falabella':
      return falabellaMarker;

    case 'plaza':
      return plazaMarker;

    case 'chilexpress':
      return chilexpressMarker;

    case 'bluexpress':
      return blueExpressMarker;

    case 'metro':
      return metroMarker;

    case 'etam':
      return etamMarker;

    case 'sybilla':
      return sybillaMarker;

    case 'americanino':
      return americaninoMarker;

    case 'clarks':
      return clarksMarker;

    case 'mango':
      return mangoMarker;

    case 'aldo':
      return aldoMarker;

    case 'carters':
      return cartersMarker;

    case 'maestro':
      return maestroMarker;

    default:
      return fcomGreenMarker;
  }
};

const formatSlotsForMap = (type, data = {}, selectedStoreId = undefined) =>
  data[type]?.map(({ latitude, longitude, operator, storeId, storeName }) => {
    return {
      longitude: Number(longitude),
      latitude: Number(latitude),
      draggable: false,
      icon: svgToDataUri(getStoreIcon(operator.toLowerCase())),
      selected: selectedStoreId === storeId,
      id: storeId,
      storeName,
    };
  });

const getOperatorIcon = (storeName) => {
  const regex = /(?:^|\s)(FALABELLA|SODIMAC|TOTTUS|HOMECENTER)/i;
  const match = storeName?.match(regex);

  if (match && match[1]) {
    return match[1].toLowerCase();
  }
  return 'falabella';
};

const getUnits = (number, stockCategoryConfig, stockCategoryLimit, textDictionary) => {
  const {
    FEW_UNITS_LEFT = 'Quedan pocas unidades',
    EXACT_UNITS_LEFT = 'Quedan solo {units} unidades',
    UNITS_AVAILABLE = 'Unidades disponibles',
    EXACT_UNITS_AVAILABLE = '{units} unidades disponibles',
  } = textDictionary || {};

  let textUnits =
    number <= stockCategoryLimit
      ? EXACT_UNITS_LEFT.replace('{units}', number)
      : EXACT_UNITS_AVAILABLE.replace('{units}', number);
  if (stockCategoryConfig === constants.STOCK_CATEGORY_CONFIG.RANGE) {
    textUnits = number <= stockCategoryLimit ? FEW_UNITS_LEFT : UNITS_AVAILABLE;
  }
  return textUnits;
};

const getMonthName = (month) => {
  const MONTHS_STRING = Object.freeze([
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ]);
  const m = parseInt(month, 10);
  return m >= 1 && m <= 12 ? MONTHS_STRING[m - 1] : '';
};

const convertToNumber = (value) => {
  if (value == null) return null;

  const cleaned = value.toString().replace(/[$,]/g, '').replace(/S\//g, '');
  const numericValue = parseFloat(cleaned);

  return Number.isNaN(numericValue) ? null : numericValue;
};

const pad = (d) => {
  return d < 10 ? `0${d.toString()}` : d.toString();
};

const formatSlotDate = (dateNum, monthKey) => {
  const day = pad(dateNum);
  const month = monthKey ? MONTHS[monthKey.toLowerCase()] : '';
  return month ? `${day}/${month}` : day;
};

const getLocaleTime = (regionCode) => {
  const requiredTimezone = _.get(timeZones, `${regionCode}`, '');
  if (requiredTimezone) {
    try {
      return new Date().toLocaleString('en-US', { timeZone: requiredTimezone });
    } catch (e) {
      return new Date().toLocaleString('en-US');
    }
  }
  return new Date().toLocaleString('en-US');
};

export {
  calculateHeightWidth,
  convertToNumber,
  formatSlotDate,
  formatSlotsForMap,
  getLocaleTime,
  getMonthName,
  getOperatorIcon,
  getStoreIcon,
  getUnits,
  pad,
};
